<template>
 <div class="card-public">
    <div class="card">
      <img :src="getImg(selectedEntry.data.image)">
      <footer class="card-footer">
      <p class="bold text1">
         {{ selectedEntry.data.title }}
      </p>
      <p class="text2" v-if="selectedEntry.data.metadata">
         {{ selectedEntry.data.metadata.categoryName}}
      </p>
      </footer>
    </div>
    <button class="change-file" @click="openSearchComponent">
          <img src="@/assets/images/return_arrow_icon.svg" class="return-icon">
          <span>{{ $t("CHANGE_UNIT") }}</span>
    </button>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import config from '@/config.js'

export default {
  name: 'unit-card',
  computed: {
    ...mapState({
      selectedEntry: state => state.collections.selectedEntry
    })
  },
  methods: {
    openSearchComponent () {
      this.$emit('openSearchComponent')
    },
    getImg (image) {
      if (image === '../img/unit_icon.png') {
        return config.classeUrl + 'img/unit_icon.png'
      } else {
        return image
      }
    }
  }
}
</script>

<style lang="scss" scoped>
 .card-public{
    display: flex; gap: 10px; align-items: flex-end; position: relative;
    width: fit-content; margin: auto; padding-bottom: 20px;
   .card{
     box-shadow: 0 3px 6px #00000029; border-radius: 7px; position: relative;
     width: 180px; max-height: 200px;
     img{
       width: 100%; object-fit: cover; max-height: 140px; height: 100%;
       border-top-left-radius: 7px; border-top-right-radius: 7px;
     }
   }
   @media all and (min-width: 769px){
     .change-file{position: absolute; inset-inline-end: -170px;}
   }
  }
</style>
